import { ILanguage } from "./base-language";

export const da_DK: ILanguage = {
  /** Routes */
  home: "/home",
  about: "/about",
  projectsMy: "/projects/my",
  detector: "/detector",
  templates: "/templates",
  register: "/register",
  registerConfirmation: "/register/confirmation",
  accountActivated: "/register/accountActivated",
  activationFailed: "/register/activationFailed",
  activationLinkExpired: "/activationLinkExpired",
  404: "/404",
  changeEmailConfirmation: "/changeEmailConfirmation",
  myAccount: "/myAccount",
  forgotPassword: "/login/forgotPassword",
  resetEmailConfirmation: "/login/resetEmailConfirmation",
  resetPassword: "/login/resetPassword/:token",
  changeEmail: "/changeEmail",
  installerView: "/installerView",
  installerViewLoggedIn: "/installerViewLoggedIn",
  project: "/project/:id",

  /** Footer links for  Customer services, Terms and conditions, Privacy policy**/
  customerServicesLink: "https://www.niko.eu/da-dk/brug-for-hj%C3%A6lp/kundeservice",
  termsAndConditionsLink: "https://www.niko.eu/da-dk/legal",
  privacyPolicyLink: "https://www.niko.eu/da-dk/legal/privacy-policy"
};
